import { find as _find } from 'lodash';
import { get, put , post } from './fetch'

export const getSellerServices = () => {
  return get(`/api/seller/services`);
}

export const getCategoryService = (categroSeoName) => {
  return get(`/api/categories/${categroSeoName}/services`, false);
}

export const getServicePrice = (serviceId) => {
  const servicePrices = [
    { serviceId: 1, minPrice: 10, maxPrice: 50 },
    { serviceId: 2, minPrice: 20, maxPrice: 60 },
    { serviceId: 3, minPrice: 15, maxPrice: 40 }
  ];
  return Promise.resolve(_find(servicePrices, (s) => s.serviceId == serviceId));
}

export const updateServicePrice = (serviceId, price) => {
  price = _.pick(price, ['priceMin', 'priceMax']);
  return put(`/api/seller/services/${serviceId}`, price);
}

export const getRequestDetails = (singleBuyerRequestID) => {
  return get(`/api/requests/${singleBuyerRequestID}`, false);
}

export const toggleServiceForSeller = (serviceList) => {
  return post(`/api/seller/service/active/toggle`, {serviceList}, true);
}

// *********************** SAAS start ***********************
export const getSCServicesList = () => {
  return get(`/api/saas/seller/services/list`);
}
export const getSCService = (scServiceID) => {
  return get(`/api/saas/seller/service/${scServiceID}`);
}
// *********************** SAAS end ***********************